import { Injectable } from '@angular/core';
import { NetworkService } from '../network/network.service';
import { AlertService } from '../alert-service.service';
import { Router } from '@angular/router';
import { AclService } from '../acl/acl.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  LOGIN_URL = '/auth/login/admin';

  constructor(
    private networkService: NetworkService,
    private aclService: AclService,
    private router: Router,
    private alert: AlertService) {
  }

  login(data: any) {
    this.networkService.httpRequest(this.LOGIN_URL, data, 'POST', false)
      .then((res: any) => {
        if (res.status) {
          this.alert.showAlert(res.message, 'success');

          localStorage.setItem('_identity_token', res.data.token);
          localStorage.setItem('_identity_role',
            res.data?.role?.name === 'ZONAL BUSINESS MANAGER' ? res.data?.role?.name :
              res.data?.role?.name === 'ZONAL HEALTH MANAGER' ? res.data?.role?.name :
                res.data?.role?.name === 'REGIONAL BUSINESS MANAGER' ? res.data?.role?.name :
                  res.data?.role?.name === 'REGIONAL HEALTH MANAGER' ? res.data?.role?.name : 'ADMIN'
          );
          this.aclService.permissions.next({
            fetched: true,
            resources: res.metaData.resources || []
          });

          localStorage.setItem('name', `${res.data.firstName} ${res.data.lastName}`);
          this.reroute(res.metaData.resources || []);
        } else {
          this.alert.showAlert(res.message,);
        }
      })
      .catch(err => this.alert.showAlert(err.message));
  }

  getPermissions() {
    this.networkService.httpRequest('/auth/admin/profile/permissions', undefined, 'GET', true)
      .then((res: any) => {
        this.aclService.permissions.next({
          fetched: true,
          resources: res?.data || []
        });
      })
      .catch(err => this.alert.showAlert(err.message));
  }

  changePassword(payload: any) {
    return this.networkService.httpRequest('/auth/admin/profile/password', payload, 'PUT', true);
  }

  forgotPassword(payload: any) {
    return this.networkService.httpRequest('/auth/open/admin/forgot-password', payload, 'PUT', true);
  }

  reroute(resources: string[]) {

    const userRoute = resources.find(resource => ['diagnostics.read', 'doctors.read', 'vles.read', 'patients.read'].includes(resource));
    if (userRoute) {
      switch (userRoute) {
        case 'patients.read':
          return this.router.navigate(['/user/customer']);
        case 'vles.read':
          return this.router.navigate(['/user/vle']);
        case 'doctors.read':
          return this.router.navigate(['/user/doctor']);
        default:
          return this.router.navigate(['/user/diagnostics']);
      }
    }

    const appointmentRoute = resources.find(resource => ['appointment.read', 'refunds.read'].includes(resource));
    if (appointmentRoute) {
      switch (appointmentRoute) {
        case 'appointment.read':
          return this.router.navigate(['/booking/doctor-appointments']);
        default:
          return this.router.navigate(['/booking/refund-request']);
      }
    }

    const inventoryRoute = resources.find(resource => ['services.read', 'static-reason.read'].includes(resource));
    if (inventoryRoute) {
      switch (inventoryRoute) {
        case 'services.read':
          return this.router.navigate(['/inventory/ailments']);
        default:
          return this.router.navigate(['/inventory/cancellation']);
      }
    }

    const contractRoute = resources.find(resource => ['contract.read'].includes(resource));
    if (contractRoute) {
      return this.router.navigate(['/contracts/active']);
    }

    const paymentRoutes = resources.find(resource => ['transactions.read', 'settlements.read'].includes(resource));
    if (paymentRoutes) {
      switch (paymentRoutes) {
        case 'transactions.read':
          return this.router.navigate(['/accounting/all-transactions']);
        default:
          return this.router.navigate(['/accounting/all-transactions']);
      }
    }

    if (resources.find(resource => ['cms.read'].includes(resource))) {
      return this.router.navigate(['/cms/contact']);
    }

    if (resources.find(resource => ['ratings.read'].includes(resource))) {
      return this.router.navigate(['/rating/operational-review']);
    }

    if (resources.find(resource => ['leads.read'].includes(resource))) {
      return this.router.navigate(['/leads/vle']);
    }

    const configurationRoutes = resources.find(resource => ['slabs.read', 'taxes.read'].includes(resource));
    if (configurationRoutes) {
      switch (configurationRoutes) {
        case 'slabs.read':
          return this.router.navigate(['/configuration/revenue-share']);
        default:
          return this.router.navigate(['/configuration/other-configuration']);
      }
    }

    return false;

  }

  getProfile() {
    this.networkService.httpRequest('/auth/admin/profile/permissions', undefined, 'GET', true)
      .then((res: any) => {
        this.aclService.permissions.next({
          fetched: true,
          resources: res?.data || []
        });
      })
      .catch(err => this.alert.showAlert(err.message));
  }

}
